exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ant-back-top {\n  background: #0198dd;\n  border-radius: 50%;\n  overflow: hidden; }\n\n.bj-banner-btn {\n  color: #000;\n  position: fixed;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  z-index: 1000;\n  background: #fff;\n  text-align: center;\n  font-size: 15px;\n  font-weight: 800;\n  right: 90px;\n  padding-top: 10px;\n  box-shadow: 0 0 3px 2px #ccc;\n  cursor: pointer; }\n\n.bj-banner-btn > div {\n  line-height: 20px; }\n\n.bj-banner-btn.bottom {\n  bottom: 120px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/pages/home/index.scss
// module id = 639
// module chunks = 0